export default {
    ROSE_MAIN: 0xffd9d9,
    ROSE_SHADOW: 0xef807f,
};
